module.exports = __webpack_public_path__ + "images/emoji/gb.3de58e60f5b4b5dadc74.png";